import React, { useState, useEffect } from 'react';
import '../Nav.css';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [menuToggle, setMenuToggle] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  // Check if user is logged in on component mount
  useEffect(() => {
    const checkAuthStatus = () => {
      // Check for token in localStorage (common approach)
      const token = localStorage.getItem('codefussion-login-token');
      // Or check for user data in context/state management if you're using that
      // const user = JSON.parse(localStorage.getItem('user'));
      
      if (token) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    checkAuthStatus();

    // Optional: Listen for storage changes (if logging in/out from other tabs)
    window.addEventListener('storage', checkAuthStatus);
    
    return () => {
      window.removeEventListener('storage', checkAuthStatus);
    };
  }, []);

  // Close menu when clicking outside or on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') setMenuToggle(false);
    };

    const handleClickOutside = (e) => {
      if (!e.target.closest('.overlay-menu') && !e.target.closest('.menuIcon')) {
        setMenuToggle(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setMenuToggle(!menuToggle);
  };

  const handleDashboardClick = () => {
    setMenuToggle(false);
    navigate('/dashboard');
  };

  return (
    <div>
      <nav id="navbar" className="">
        <div className="nav-wrapper">
          <div className="logo">
            {/* <a href="#home"><img src="https://codeflarelimited.com/assets/images/codeflare-app.webp" alt="Codeflare" /></a> */}
            <a href="#home">Codeflare</a>
          </div>

          <ul id="menu">
            <Link to="/"><li><a href="#home">Home</a></li></Link>
            <li><a href="#services">Catalogue</a></li>
            <li><a href="#services">Paths</a></li>
            <Link to="/plans"><li><a href="#" onClick={() => setMenuToggle(false)}>Plans</a></li></Link>
            <li><a href="#contact">Contact</a></li>
            
            {/* Conditionally render login/create account or dashboard link */}
            {!isLoggedIn ? (
              <>
                <Link to="/login"><li><a href="#" onClick={() => setMenuToggle(false)}>Login</a></li></Link>
                <Link to="/create-account"><li><a href="#" onClick={() => setMenuToggle(false)}>Create Account</a></li></Link>
              </>
            ) : (
              <li>
                <a href="#" onClick={handleDashboardClick} style={{cursor: 'pointer'}}>
                  Go to Dashboard
                </a>
              </li>
            )}
          </ul>
        </div>
      </nav>

      <div 
        className={`menuIcon ${menuToggle ? 'toggle' : ''}`} 
        onClick={toggleMenu}
      >
        <span className="icon icon-bars"></span>
        <span className="icon icon-bars overlay"></span>
      </div>

      <div className={`overlay-menu ${menuToggle ? 'open' : ''}`}>
        <ul id="menu">
          <li><a href="#" onClick={() => setMenuToggle(false)}>Home</a></li>
          <li><a href="#" onClick={() => setMenuToggle(false)}>Catalogue</a></li>
          <li><a href="#" onClick={() => setMenuToggle(false)}>Paths</a></li>
          <Link to="/plans"><li><a href="#about" onClick={() => setMenuToggle(false)}>Plans</a></li></Link>
          <li><a href="#contact" onClick={() => setMenuToggle(false)}>Contact</a></li>
          
          {/* Conditionally render login/create account or dashboard link in mobile menu */}
          {!isLoggedIn ? (
            <>
              <Link to="/login"><li><a href="#" onClick={() => setMenuToggle(false)}>Login</a></li></Link>
              <Link to="/create-account"><li><a href="#" onClick={() => setMenuToggle(false)}>Create Account</a></li></Link>
            </>
          ) : (
            <li>
              <a href="#" onClick={handleDashboardClick} style={{cursor: 'pointer'}}>
                Go to Dashboard
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;